﻿import CONSTANTS from '../utils/constants.js';

export const getProgress = (key) => {
    try {
        const savedProgress = localStorage.getItem(key);
        return savedProgress ? JSON.parse(savedProgress) : {
            ServicesAccessible: false,
            AdditionalDetailsAccessible: false,
            SummaryAccessible: false,
            WaybillAccessible: false,
            calculatorFormDirty: false, 
            servicesFormDirty: false, 
            additionalDetailsFormDirty: false,
            summaryFormDirty: false,
        };
    } catch (error) {
        console.warn(`Failed to parse progress from localStorage: ${error}`);
        return {
            ServicesAccessible: false,
            AdditionalDetailsAccessible: false,
            SummaryAccessible: false,
            WaybillAccessible: false,
            calculatorFormDirty: false,
            servicesFormDirty: false, 
            additionalDetailsFormDirty: false,
            summaryFormDirty: false,
        };
    }
};

export const saveProgress = (key, progress) => {
    try {
        localStorage.setItem(key, JSON.stringify(progress));
    } catch (error) {
        console.warn(`Failed to save progress to localStorage: ${error}`);
    }
};

export const clearProgress = (key) => {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        console.warn(`Failed to clear progress from localStorage: ${error}`);
    }
};

export const resetProgress = () => {
    clearProgress(CONSTANTS.PROGRESS_KEY);
    const clearedProgress = getProgress(CONSTANTS.PROGRESS_KEY);
    saveProgress(CONSTANTS.PROGRESS_KEY, clearedProgress);
};

const isNewSession = (currentPath) =>
    currentPath === '/' || (currentPath === '/quote' && !document.querySelector('.filter-results-table')) ||
    currentPath === '/successpayment';

export const initSession = () => {
    const currentPath = window.location.pathname.toLowerCase();
    if (isNewSession(currentPath)) {
        clearProgress(CONSTANTS.PROGRESS_KEY);
    }
};

initSession();